import { FileTextIcon, Link2Icon, NewspaperIcon } from 'lucide-react';
import { RESOURCE_FORMAT, type ResourceFormat } from '@/lib/resources';

const ICONS: Readonly<Record<ResourceFormat, React.ReactNode>> = {
  [RESOURCE_FORMAT.article]: <NewspaperIcon aria-hidden className="size-4" />,
  [RESOURCE_FORMAT.file]: <FileTextIcon aria-hidden className="size-4" />,
  [RESOURCE_FORMAT.link]: <Link2Icon aria-hidden className="size-4" />,
};

/**
 * The small tile beside a resource's title in admin tables: an article, a
 * file or a link at a glance.
 *
 * @param props - The format.
 * @returns The tile.
 */
export function ResourceFormatIcon({ format }: { readonly format: ResourceFormat }): React.ReactElement {
  return <span className="grid size-9 shrink-0 place-items-center rounded-lg bg-brand-tint text-brand">{ICONS[format]}</span>;
}
